import { create, useStore } from "zustand";
import {
  CampaignsTabsEnum,
  ICampaign,
  ICampaignsRule,
  IProject,
  ITask
} from "./types";

export interface ICampaignsStore {
  isOpenAddCampaignForm: boolean;
  isOpenAddProjectForm: boolean;
  isLoading: boolean;
  isCampaignIteracting: boolean;
  isLoadMoreLoading: boolean;
  campaignsPage: number;
  hasMoreCampaigns: boolean;
  totalCampaignsPages: number;
  projectsPage: number;
  hasMoreProjects: boolean;
  totalProjectsPages: number;
  selectedTab: CampaignsTabsEnum;
  campaigns: ICampaign[];
  projects: IProject[];
  selectedProject: null | IProject;
  selectedCampaigns: null | ICampaign;
  campaignRules: ICampaignsRule[];
  setIsLoading: (isAddLoading: boolean) => void;
  setIsCampaignIteracting: (isCampaignIteracting: boolean) => void;
  setIsLoadMoreLoading: (isLoadMoreLoading: boolean) => void;
  setCampaignsPage: (campaignsPage: number) => void;
  setHasMoreCampaigns: (hasMoreCampaigns: boolean) => void;
  setTotalCampaignsPages: (totalCampaignsPages: number) => void;
  setProjectsPage: (projectsPage: number) => void;
  setHasMoreProjects: (hasMoreProjects: boolean) => void;
  setTotalProjectsPages: (totalProjectsPages: number) => void;
  setIsOpenAddCampaignForm: (isOpenAddCampaignForm: boolean) => void;
  setIsOpenAddProjectForm: (isOpenAddProjectForm: boolean) => void;
  setSelectedTab: (selectedTab: CampaignsTabsEnum) => void;
  setCampaigns: (campaigns: ICampaign[]) => void;
  setProjects: (projects: IProject[]) => void;
  setSelectedProject: (project: IProject | null) => void;
  setSelectedCampaign: (project: ICampaign | null) => void;
  setCampaignRules: (campaignRules: ICampaignsRule[]) => void;
  TASKS: {
    page: number;
    setPage: (value: number) => void;
    pageSize: number;
    setPageSize: (value: number) => void;
    hasMore: boolean;
    totalPages: number;
    tasks: ITask[];
    setTasks: (value: ITask[]) => void;
    selectedTask: ITask | null;
    setSelectedTask: (value: ITask | null) => void;
    isOpenAddTaskForm: boolean;
    setIsOpenAddTaskForm: (value: boolean) => void;
    setTotalPages: (totalPages: number) => void;
  };
}

export const campaignsStore = create<ICampaignsStore>((set) => ({
  isOpenAddCampaignForm: false,
  isOpenAddProjectForm: false,
  isLoading: false,
  isCampaignIteracting: false,
  campaignsPage: 1,
  hasMoreCampaigns: false,
  isLoadMoreLoading: false,
  projectsPage: 1,
  hasMoreProjects: false,
  totalProjectsPages: 0,
  totalCampaignsPages: 0,
  selectedTab: CampaignsTabsEnum.CAMPAIGNS,
  campaigns: [],
  projects: [],
  selectedCampaigns: null,
  selectedProject: null,
  campaignRules: [],
  setIsCampaignIteracting: (isCampaignIteracting) =>
    set({ isCampaignIteracting }),
  setSelectedCampaign: (campaign: ICampaign | null) =>
    set({ selectedCampaigns: campaign }),
  setSelectedProject: (proj) => set({ selectedProject: proj }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setIsLoadMoreLoading: (isLoadMoreLoading) => set({ isLoadMoreLoading }),
  setCampaignsPage: (campaignsPage) => set({ campaignsPage }),
  setHasMoreCampaigns: (hasMoreCampaigns) => set({ hasMoreCampaigns }),
  setTotalCampaignsPages: (totalCampaignsPages) => set({ totalCampaignsPages }),
  setProjectsPage: (projectsPage) => set({ projectsPage }),
  setHasMoreProjects: (hasMoreProjects) => set({ hasMoreProjects }),
  setTotalProjectsPages: (totalProjectsPages) => set({ totalProjectsPages }),
  setIsOpenAddCampaignForm: (isOpenAddCampaignForm) =>
    set({ isOpenAddCampaignForm }),
  setIsOpenAddProjectForm: (isOpenAddProjectForm) =>
    set({ isOpenAddProjectForm }),
  setSelectedTab(selectedTab) {
    set({ selectedTab });
  },
  setCampaigns(campaigns) {
    set({ campaigns });
  },
  setProjects(projects) {
    set({ projects });
  },
  setCampaignRules: (campaignRules) => set({ campaignRules }),
  TASKS: {
    page: 1,
    setPage: (value: number) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          page: value
        }
      }));
    },
    pageSize: 10,
    setPageSize: (value: number) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          pageSize: value
        }
      }));
    },
    hasMore: false,
    totalPages: 0,
    tasks: [],
    setTasks: (value) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          tasks: value
        }
      }));
    },
    selectedTask: null,
    setSelectedTask: (value) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          selectedTask: value
        }
      }));
    },
    isOpenAddTaskForm: false,
    setIsOpenAddTaskForm: (value) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          isOpenAddTaskForm: value
        }
      }));
    },
    setTotalPages: (totalPages) => {
      set((state) => ({
        TASKS: {
          ...state.TASKS,
          totalPages
        }
      }));
    }
  }
}));

export const useCampaignsStore = () => useStore(campaignsStore);
